import { getCurrentInstance } from 'vue';

export const getTemplateConfig = () => {
    const { $isAppEnvironment } = getCurrentInstance()?.proxy || {};

    return {
        topbar: !$isAppEnvironment,
    };
};
